"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function constructElement(providers, element) {
    return Object.keys(providers).reduce(function (children, key) {
        return providers[key].component(children);
    }, element);
}
exports.constructElement = constructElement;
function collectDependencies(providers) {
    return Object.keys(providers).reduce(function (dependencies, key) {
        dependencies[key] = providers[key].provider;
        return dependencies;
    }, {});
}
exports.collectDependencies = collectDependencies;
function ensureSlash(path) {
    return path.endsWith('/') ? path : path + '/';
}
exports.ensureSlash = ensureSlash;
//# sourceMappingURL=helpers.js.map